import { render, staticRenderFns } from "./DescriptionCell.vue?vue&type=template&id=2067aff3&scoped=true&"
import script from "./DescriptionCell.vue?vue&type=script&lang=js&"
export * from "./DescriptionCell.vue?vue&type=script&lang=js&"
import style0 from "./DescriptionCell.vue?vue&type=style&index=0&id=2067aff3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2067aff3",
  null
  
)

export default component.exports